<template>
	<div class="content-wrapper">
		<div class="row">
			<div class="col-12 mb-primary">
				<div class="card card-with-shadow border-0 h-10">
					<div class="card-header p-primary bg-transparent"></div>
					<app-overlay-loader v-if="preloader" />
					<div class="card-body">
						<!-- Invoice Request Form -->
						<div class="col-md-12">
							<app-breadcrumb page-title="Invoice Request" />
							<hr
								style="
									border-top: 2px solid black;
									font-weight: bold;
								"
							/>
							<form
								ref="form"
								:data-url="`/transaction/invoice/${id}`"
								class="mb-0"
								:class="{ 'loading-opacity': preloader }"
							>
								<div class="row">
									<div class="col-lg-12">
										<div class="row">
											<div class="col-md-3">
												<div class="form-group">
													<label>Reference ID</label>
													<app-input
														type="text"
														placeholder="Reference ID"
														v-model="
															invoiceRequestForm.reference_id
														"
														name="reference_id"
														:required="true"
														:disabled="
															isView ||
															invoiceRequestForm.status !=
																'Requested'
														"
													/>
												</div>
											</div>

											<div class="col-md-2">
												<div class="form-group">
													<label>Request Date</label>
													<app-input
														type="date"
														v-model="
															invoiceRequestForm.request_date
														"
														name="request_date"
														placeholder="Request Date"
														:required="true"
														:disabled="
															isView ||
															invoiceRequestForm.status !=
																'Requested'
														"
													/>
												</div>
											</div>

											<div class="col-md-2">
												<div class="form-group">
													<label
														>Invoice Send To</label
													>
													<app-input
														type="search-select"
														placeholder="Invoice Send To"
														v-model="
															invoiceRequestForm.request_send_to
														"
														name="request_send_to"
														:list="
															invoiceSendToLists
														"
														:disabled="true"
														:required="true"
													/>
												</div>
											</div>

											<div class="col-md-2">
												<div class="form-group">
													<label
														>Scheduled Print
														Date</label
													>
													<app-input
														type="date"
														v-model="
															invoiceRequestForm.request_print_date
														"
														name="request_print_date"
														placeholder="Scheduled Print Date"
														:required="true"
														:disabled="
															isView ||
															invoiceRequestForm.status !=
																'Requested'
														"
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label>CLC Center</label>
													<app-input
														type="search-select"
														name="center_id"
														v-model="
															invoiceRequestForm.center_id
														"
														:list="centerIdLists"
														placeholder="CLC Center"
														:required="true"
														:disabled="
															isView ||
															invoiceRequestForm.status !=
																'Requested'
														"
													/>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-3">
												<div class="form-group">
													<label
														>Invoice Request
														No</label
													>
													<app-input
														type="text"
														placeholder="Invoice Request No"
														v-model="
															invoiceRequestForm.request_no
														"
														name="request_no"
														:required="true"
														:disabled="true"
													/>
												</div>
											</div>

											<div class="col-md-2">
												<div class="form-group">
													<label>Requested By</label>
													<app-input
														type="search-select"
														placeholder="Requested By"
														v-model="
															invoiceRequestForm.request_user_id
														"
														name="request_user_id"
														:list="requestedByLists"
														:required="true"
														:disabled="
															isView ||
															invoiceRequestForm.status !=
																'Requested'
														"
													/>
												</div>
											</div>

											<div class="col-md-2">
												<div class="form-group">
													<label
														>Invoice Send Via</label
													>
													<app-input
														placeholder="Invoice Send Via"
														type="search-select"
														:list="
															invoiceSentViaLists
														"
														name="invoice_sent_via"
														v-model="
															invoiceRequestForm.request_send_via
														"
														:required="true"
														:disabled="
															isView ||
															invoiceRequestForm.status !=
																'Requested'
														"
													/>
												</div>
											</div>

											<div class="col-md-2">
												<div class="form-group">
													<label
														>Invoice Due Date</label
													>
													<app-input
														type="date"
														v-model="
															invoiceRequestForm.due_date
														"
														name="due_date"
														placeholder="Invoice Due Date"
														:required="true"
														:disabled="
															isView ||
															invoiceRequestForm.status !=
																'Requested'
														"
													/>
												</div>
											</div>

											<div class="col-md-3">
												<div class="form-group">
													<label>Bank Account</label>
													<app-input
														type="search-select"
														name="bank_account_id"
														v-model="
															invoiceRequestForm.bank_account_id
														"
														:list="
															bankAccountIdLists
														"
														placeholder="Bank Account"
														:required="true"
														:disabled="
															isView ||
															invoiceRequestForm.status !=
																'Requested'
														"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="mt-5 mb-5 action-buttons">
									<button
										type="submit"
										class="btn btn-primary mr-2"
										:disabled="
											this.invoiceRequestForm
												.invoice_no != null ||
											this.invoiceRequestForm.status ==
												'Cancelled' ||
											isView
										"
										@click.prevent="submitInvoiceRequest"
									>
										Submit
									</button>
								</div>
							</form>
						</div>

						<!-- Study Information Table -->
						<div class="col-md-12 mt-8">
							<student-profile-tab-finance-study-information-table
								:invoiceRequestId="id"
							></student-profile-tab-finance-study-information-table>
						</div>

						<!-- Fees Notice Details -->
						<div class="col-md-12 mt-8">
							<student-profile-tab-finance-fees-notice-details-table
								:invoiceRequestId="id"
							></student-profile-tab-finance-fees-notice-details-table>
						</div>

						<!-- Fees Notice Details Charges -->
						<div class="col-md-12 mt-8">
							<student-profile-tab-finance-fees-notice-details-charges-table
								:invoiceRequestId="id"
								:isProcessed="
									this.invoiceRequestForm.invoice_no !=
										null ||
									this.invoiceRequestForm.status ==
										'Cancelled'
								"
								:isView="isView"
							/>
						</div>

						<!-- Fees Notice Details Deductions -->
						<div class="col-md-12 mt-8">
							<student-profile-tab-finance-fees-notice-details-deductions-table
								:invoiceRequestId="id"
								:isProcessed="
									this.invoiceRequestForm.invoice_no !=
										null ||
									this.invoiceRequestForm.status ==
										'Cancelled'
								"
								:isView="isView"
							/>
						</div>

						<!-- Summary -->
						<div class="col-md-12 mt-8">
							<div class="row">
								<div class="col-md-4"></div>
								<div class="col-md-8">
									<!-- Total Charges -->
									<div class="row">
										<div class="col-md-6"></div>
										<div class="col-md-6">
											<div
												class="form-group row align-items-center"
											>
												<label
													for="footerInputs_total_charges"
													class="col-sm-3 mb-0"
												>
													Total Charges
												</label>
												<app-input
													id="footerInputs_total_charges"
													class="col-sm-9"
													type="currency-right"
													v-model="
														footerInputs.total_charges
													"
													placeholder="Total Charges"
													:disabled="true"
												/>
											</div>
										</div>
									</div>
									<!-- Total Deductions -->
									<div class="row">
										<div class="col-md-6"></div>
										<div class="col-md-6">
											<div
												class="form-group row align-items-center"
											>
												<label
													for="footerInputs_total_deductions"
													class="col-sm-3 mb-0"
												>
													Total Deductions
												</label>
												<app-input
													id="footerInputs_total_deductions"
													class="col-sm-9"
													type="currency-right"
													v-model="
														footerInputs.total_deductions
													"
													placeholder="Total Deductions"
													:disabled="true"
												/>
											</div>
										</div>
									</div>
									<!-- Total Amount Due -->
									<div class="row">
										<div class="col-md-6"></div>
										<div class="col-md-6">
											<div
												class="form-group row align-items-center"
											>
												<label
													for="footerInputs_amount_due"
													class="col-sm-3 mb-0"
												>
													Amount Due
												</label>
												<app-input
													id="footerInputs_amount_due"
													class="col-sm-9"
													type="currency-right"
													v-model="
														footerInputs.amount_due
													"
													placeholder="Amount Due"
													:disabled="true"
												/>
											</div>
										</div>
									</div>
									<!-- Tax -->
									<div class="row">
										<div class="col-md-6"></div>
										<div class="col-md-6">
											<div
												class="form-group row align-items-center"
											>
												<label
													for="footerInputs_vat_amount"
													class="col-sm-3 mb-0"
												>
													Tax (%)
												</label>
												<app-input
													id="footerInputs_vat_percent"
													class="col-sm-3"
													type="number"
													v-model="
														footerInputs.vat_percent
													"
													placeholder="Tax (%)"
													:disabled="
														this.invoiceRequestForm
															.status !=
														'Requested'
													"
												/>
												<app-input
													id="footerInputs_vat_amount"
													class="col-sm-6"
													type="currency-right"
													v-model="
														footerInputs.vat_amount
													"
													placeholder="Tax"
													:disabled="true"
												/>
											</div>
										</div>
									</div>
									<!-- Admin Fee -->
									<div class="row">
										<div class="col-md-6"></div>
										<div class="col-md-6">
											<div
												class="form-group row align-items-center"
											>
												<label
													for="footerInputs_admin_fee"
													class="col-sm-3 mb-0"
												>
													Admin Fee
												</label>
												<app-input
													id="footerInputs_admin_fee"
													class="col-sm-9"
													type="currency-right"
													v-model="
														footerInputs.admin_fee
													"
													placeholder="Admin Fee"
													:disabled="
														this.invoiceRequestForm
															.status !=
														'Requested'
													"
												/>
											</div>
										</div>
									</div>
									<!-- Grand Total -->
									<div class="row">
										<div class="col-md-6"></div>
										<div class="col-md-6">
											<div
												class="form-group row align-items-center"
											>
												<label
													for="footerInputs_grand_total"
													class="col-sm-3 mb-0"
												>
													Grand Total
												</label>
												<app-input
													id="footerInputs_grand_total"
													class="col-sm-9"
													type="currency-right"
													v-model="
														footerInputs.grand_total
													"
													placeholder="Grand Total"
													:disabled="true"
												/>
											</div>
										</div>
									</div>
									<div class="row mt-4">
										<div class="col-md-6"></div>
										<div class="col-md-6">
											<button
												class="btn btn-danger"
												@click.prevent="cancelInvoice"
												v-if="
													this.invoiceRequestForm
														.status !=
														'Cancelled' && !isView
												"
											>
												Cancel
											</button>
											<button
												class="btn btn-secondary"
												@click.prevent="
													duplicateInvoice
												"
												v-if="
													this.invoiceRequestForm
														.status ==
														'Cancelled' && !isView
												"
											>
												Duplicate Invoice
											</button>
											<button
												v-if="this.$can('view_list_student_studentprofile_tab_finance_create_invoice')"
												class="btn btn-primary"
												:disabled="
													this.invoiceRequestForm
														.invoice_no != null ||
													this.invoiceRequestForm
														.status ==
														'Cancelled' ||
													isView ||
													this.footerInputs
														.grand_total_ori == 0
												"
												@click.prevent="
													goToInvoiceProcess
												"
											>
												Invoice Process
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { InvoiceRequestFormMixin } from "./InvoiceRequestFormMixin.js";
import GlobalHelperMixin from "../../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	name: "InvoiceRequest",
	inject: ["eventHub"],
	mixins: [InvoiceRequestFormMixin, GlobalHelperMixin],
	data() {
		return {
			preloader: false,
			sameAsAbove: false,
			id: null,
			isView: false,
			footerInputs: {
				total_charges: this.formattedIDR(0),
				total_charges_ori: 0,
				total_deductions: this.formattedIDR(0),
				total_deductions_ori: 0,
				amount_due: this.formattedIDR(0),
				amount_due_ori: 0,
				vat_percent: 0,
				vat_amount: this.formattedIDR(0),
				vat_amount_ori: 0,
				admin_fee: 0,
				admin_fee_ori: 0,
				grand_total: this.formattedIDR(0),
				grand_total_ori: 0,
			},
			invoiceRequestForm: {
				reference_id: null,
				request_date: null,
				request_send_to: null,
				request_print_date: null,
				center_id: null,
				request_no: null,
				request_user_id: null,
				request_send_via: null,
				due_date: null,
				invoice_no: null,
				bank_account_id: null,
			},
			requestedByLists: [],
			invoiceSendToLists: [],
			centerIdLists: [],
			bankAccountIdLists: [],
			invoiceSentViaLists: [
				{ id: "Email", value: "Email" },
				{ id: "WhatsApp", value: "WhatsApp" },
			],
			invoiceRequestData: {},
		};
	},
	created() {
		let url = window.location.href;
		this.id = parseInt(url.split("/").slice(-1)[0].split("?")[0]);
		this.isView = url.includes("view");

		this.fetchData("created");
	},
	mounted() {
		this.eventHub.$on("studentFeesNoticeDetailsChargesChanged", () => {
			this.updateSummaryDataOnEvent();
		});
		this.eventHub.$on("studentFeesNoticeDetailsDeductionChanged", () => {
			this.updateSummaryDataOnEvent();
		});
	},
	methods: {
		async fetchData(from) {
			try {
				let [
					invoiceRequestResponse,
					userResponse,
					bankAccountResponse,
					centerIdResponse,
				] = await Promise.all([
					axios.get(`/transaction/invoice/${this.id}`),
					axios.get("/user-list?per_page=50"),
					axios.get("/master/bank-account?is_active=true"),
					axios.get("/master/center?is_active=true"),
				]);

				if (from == "created") {
					this.invoiceSendToLists.push({
						id: invoiceRequestResponse.data.request_send_to.id,
						value: invoiceRequestResponse.data.parent_name,
					});

					userResponse.data.data.forEach((item) => {
						this.requestedByLists.push({
							id: item.id,
							value: item.full_name
								? item.full_name
								: item.first_name + " " + item.last_name,
						});
					});

					bankAccountResponse.data.data.forEach((item) => {
						this.bankAccountIdLists.push({
							id: item.id,
							value:
								item.bank_account_name +
								" - " +
								item.bank_account_no,
						});
					});

					centerIdResponse.data.data.forEach((item) => {
						this.centerIdLists.push({
							id: item.id,
							value: item.name,
						});
					});

					this.invoiceRequestForm.request_send_to =
						invoiceRequestResponse.data.request_send_to?.id;
					this.invoiceRequestForm.request_user_id =
						invoiceRequestResponse.data.request_user_id?.id;
					this.invoiceRequestForm.request_send_via =
						invoiceRequestResponse.data.request_send_via;
					this.invoiceRequestForm.bank_account_id =
						invoiceRequestResponse.data.bank_account_id
							? invoiceRequestResponse.data.bank_account_id.id
							: null;
					this.invoiceRequestForm.center_id =
						invoiceRequestResponse.data.center_id?.id;
				}

				this.invoiceRequestForm.reference_id =
					invoiceRequestResponse.data.reference_id ?? null;
				this.invoiceRequestForm.clc_id_number =
					invoiceRequestResponse.data.clc_id_number;
				this.invoiceRequestForm.request_date =
					invoiceRequestResponse.data.request_date;
				this.invoiceRequestForm.request_print_date =
					invoiceRequestResponse.data.request_print_date;
				this.invoiceRequestForm.request_no =
					invoiceRequestResponse.data.request_no;
				this.invoiceRequestForm.due_date =
					invoiceRequestResponse.data.due_date;
				this.invoiceRequestForm.remarks =
					invoiceRequestResponse.data.remarks ?? null;
				this.invoiceRequestForm.status =
					invoiceRequestResponse.data.status;
				this.invoiceRequestForm.invoice_no =
					invoiceRequestResponse.data.invoice_no;

				this.footerInputs.total_charges = this.formattedIDR(
					invoiceRequestResponse.data.total_charges
				);
				this.footerInputs.total_charges_ori = parseFloat(
					invoiceRequestResponse.data.total_charges
				);
				this.footerInputs.total_deductions = this.formattedIDR(
					invoiceRequestResponse.data.total_deductions
				);
				this.footerInputs.amount_due = this.formattedIDR(
					invoiceRequestResponse.data.total_charges -
						invoiceRequestResponse.data.total_deductions
				);
				this.footerInputs.amount_due_ori = parseFloat(
					invoiceRequestResponse.data.total_charges -
						invoiceRequestResponse.data.total_deductions
				);
				this.footerInputs.vat_percent =
					invoiceRequestResponse.data.vat_percent == 0.0
						? 0
						: invoiceRequestResponse.data.vat_percent;
				this.footerInputs.vat_amount = this.formattedIDR(
					invoiceRequestResponse.data.vat_amount
				);
				this.footerInputs.vat_amount_ori = parseFloat(
					invoiceRequestResponse.data.vat_amount
				);
				this.footerInputs.total_deductions_ori = parseFloat(
					invoiceRequestResponse.data.total_deductions
				);
				this.footerInputs.admin_fee =
					invoiceRequestResponse.data.admin_fee == 0.0
						? 0
						: this.formattedIDR(
								invoiceRequestResponse.data.admin_fee
						  );
				this.footerInputs.admin_fee_ori = invoiceRequestResponse.data
					.admin_fee
					? parseFloat(invoiceRequestResponse.data.admin_fee)
					: 0;
				this.footerInputs.grand_total = this.formattedIDR(
					invoiceRequestResponse.data.grand_total
				);
				this.footerInputs.grand_total_ori = parseFloat(
					invoiceRequestResponse.data.grand_total
				);
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		async updateSummaryDataOnEvent() {
			try {
				const updatedSummaryData = await axios.get(
					`/transaction/invoice/${this.id}`
				);

				// Destructuring for easy access
				const { data, status } = updatedSummaryData;

				// Update footerInputs object
				this.footerInputs = {
					total_charges: this.formattedIDR(data.total_charges),
					total_charges_ori: parseFloat(data.total_charges),
					total_deductions: this.formattedIDR(data.total_deductions),
					total_deductions_ori: parseFloat(data.total_deductions),
					amount_due: this.formattedIDR(
						data.total_charges - data.total_deductions
					),
					amount_due_ori: parseFloat(
						data.total_charges - data.total_deductions
					),
					vat_percent:
						status != "Requested"
							? data.vat_percent == 0.0
								? 0
								: data.vat_percent
							: this.footerInputs.vat_percent,
					vat_amount: this.formattedIDR(data.vat_amount),
					vat_amount_ori: parseFloat(data.vat_amount),
					admin_fee:
						status != "Requested"
							? data.admin_fee && data.admin_fee != 0
								? this.formattedIDR(data.admin_fee)
								: 0
							: this.footerInputs.admin_fee,
					admin_fee_ori:
						status != "Requested"
							? data.admin_fee
								? data.admin_fee
								: 0
							: this.footerInputs.admin_fee_ori,
					grand_total: this.formattedIDR(data.grand_total),
					grand_total_ori: parseFloat(data.grand_total),
				};
			} catch (error) {
				console.error("Error updating summary data on event:", error);
			}
		},
		beforeSubmit() {
			this.preloader = true;
		},
		submitInvoiceRequest() {
			this.invoiceRequestForm.request_date = this.formattedDate(
				this.invoiceRequestForm.request_date
			);
			this.invoiceRequestForm.request_print_date = this.formattedDate(
				this.invoiceRequestForm.request_print_date
			);
			this.invoiceRequestForm.due_date = this.formattedDate(
				this.invoiceRequestForm.due_date
			);
			this.save(this.invoiceRequestForm);
		},
		afterSuccess(res) {
			this.$toastr.s(res.data.message);
			this.clear();
		},
		afterFinalResponse() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterError(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		cancelInvoice() {
			// sweetalert
			Swal.fire({
				title: "Are you sure?",
				text: "You won't be able to revert this!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes, cancel it!",
				cancelButtonText: "No, cancel!",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					// sweetalert
					Swal.fire({
						title: "Success",
						text: "Invoice Request Cancelled",
						icon: "success",
					});

					axios.put(`/transaction/invoice/${this.id}`, {
						status: "Cancelled",
					});

					this.fetchData("cancelInvoice");
				} else if (result.dismiss === Swal.DismissReason.cancel) {
					Swal.fire({
						title: "Cancelled",
						text: "Cancel Invoice Request Cancelled :)",
						icon: "error",
					});
				}
			});
		},
		duplicateInvoice() {
			// sweetalert
			Swal.fire({
				title: "Are you sure?",
				text: "You won't be able to revert this!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes, duplicate invoice!",
				cancelButtonText: "No, cancel!",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					// sweetalert
					Swal.fire({
						title: "Success",
						text: "Invoice Duplicated Successfully",
						icon: "success",
					}).then(() => {
						axios
							.post(`/transaction/invoice/${this.id}/duplicate`)
							.then((res) => {
								let url =
									"/transaction/profile-student/finance/invoice-request/edit/" +
									res.data.data.id;
								window.open(url, "_blank");
							})
							.catch((err) => {
								console.log(err);
							});
					});
				} else if (result.dismiss === Swal.DismissReason.cancel) {
					Swal.fire({
						title: "Cancelled",
						text: "Cancelled Invoice Duplicate :)",
						icon: "error",
					});
				}
			});
		},

		goToInvoiceProcess() {
			// check invoiceRequestForm.bank_account_id
			if (
				this.invoiceRequestForm.bank_account_id == null ||
				this.invoiceRequestForm.bank_account_id == "" ||
				this.invoiceRequestForm.center_id == null ||
				this.invoiceRequestForm.center_id == ""
			) {
				Swal.fire({
					title: "Error",
					text: "Please fill Bank Account and CLC Center first",
					icon: "error",
				});
				return;
			}

			// sweetalert
			Swal.fire({
				title: "Are you sure?",
				text: "You won't be able to revert this!",
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: "Yes, create it!",
				cancelButtonText: "No, cancel!",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					// sweetalert
					Swal.fire({
						title: "Success",
						text: "Invoice Processed",
						icon: "success",
					}).then(() => {
						axios
							.put(`/transaction/invoice/${this.id}`, {
								status: "Processed",
								vat_percent: this.footerInputs.vat_percent,
								vat_amount: this.footerInputs.vat_amount_ori,
								admin_fee: this.footerInputs.admin_fee_ori,
							})
							.then((res) => {
								let url =
									"/transaction/profile-student/finance/invoice-process/pdf/" +
									this.id;
								window.open(url, "_blank");
							})
							.catch((err) => {
								console.log(err);
							});

						this.fetchData("goToInvoiceProcess");
					});
				} else if (result.dismiss === Swal.DismissReason.cancel) {
					Swal.fire({
						title: "Cancelled",
						text: "Create Invoice Process Cancelled :)",
						icon: "error",
					});
				}
			});
		},

		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
		countVatPercent(newVal) {
			if (newVal == "" || isNaN(newVal)) {
				this.footerInputs.vat_percent = 0;
			} else if (parseFloat(newVal) > 100) {
				this.footerInputs.vat_percent = 100;
			} else if (parseFloat(newVal) < 0) {
				this.footerInputs.vat_percent = 0;
			} else {
				this.footerInputs.vat_percent = parseFloat(newVal);
			}

			let amountDue = this.footerInputs.amount_due_ori;
			let newVatAmount =
				(this.footerInputs.vat_percent * amountDue) / 100;
			let newGrandTotal =
				amountDue +
				newVatAmount +
				parseFloat(this.footerInputs.admin_fee_ori);

			this.footerInputs.vat_amount = this.formattedIDR(newVatAmount);
			this.footerInputs.vat_amount_ori = newVatAmount;

			this.footerInputs.grand_total = this.formattedIDR(newGrandTotal);
			this.footerInputs.grand_total_ori = newGrandTotal;
		},
		countAdminFee(newVal) {
			if (newVal == "" || isNaN(newVal)) {
				this.footerInputs.admin_fee = 0;
				this.footerInputs.admin_fee_ori = 0;
			} else {
				this.footerInputs.admin_fee = parseFloat(newVal);
				this.footerInputs.admin_fee_ori = parseFloat(newVal);
			}

			let amountDue = this.footerInputs.amount_due_ori;
			let newGrandTotal =
				amountDue +
				this.footerInputs.vat_amount_ori +
				this.footerInputs.admin_fee_ori;

			this.footerInputs.admin_fee = this.formattedIDR(
				parseFloat(isNaN(newVal) ? 0 : newVal)
			);

			this.footerInputs.grand_total = this.formattedIDR(newGrandTotal);
			this.footerInputs.grand_total_ori = newGrandTotal;
		},
	},
	watch: {
		"footerInputs.vat_percent": function (newVal, oldVal) {
			this.countVatPercent(parseFloat(newVal));
		},
		"footerInputs.admin_fee": function (newVal, oldVal) {
			this.countAdminFee(parseFloat(newVal.replace(/\D/g, "")));
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
.form-control {
	border: 3px solid; /* You can adjust the border color and width as needed = #c41a1a !important; */
}
.required-star {
	color: red;
}

.card {
	box-shadow: 0 18px 20px rgba(0, 0, 0, 0.2); /* You can adjust the values to control the shadow effect */
}
</style>
